var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "scheduled-list"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitflt.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Connection Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-signs'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.connectiontype),
      expression: "connectiontype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('ConnectionType')
    },
    attrs: {
      "name": "ConnectionType",
      "id": "ConnectionType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.connectiontype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Connection Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Network")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Local-TP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("Biker")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ConnectionType')),
      expression: "errors.has('ConnectionType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Connection Type field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Trip Sheet No")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tripsheetnoflt),
      expression: "tripsheetnoflt"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Trip Sheet No",
      "name": "TripSheetNo",
      "id": "TripSheetNo"
    },
    domProps: {
      "value": (_vm.tripsheetnoflt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tripsheetnoflt = $event.target.value
      }
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Status")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('Status')
    },
    attrs: {
      "name": "Status",
      "id": "Status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pending"
    }
  }, [_vm._v("Pending")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "InProcess"
    }
  }, [_vm._v("InProcess")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Status')),
      expression: "errors.has('Status')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Status field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("From Date")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control1': true, 'error': _vm.errors.has('FromDate')
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "name": "FromDate"
    },
    model: {
      value: (_vm.fromdate),
      callback: function($$v) {
        _vm.fromdate = $$v
      },
      expression: "fromdate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('FromDate')),
      expression: "errors.has('FromDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('FromDate')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("To Date")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control1': true, 'error': _vm.errors.has('ToDate')
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "name": "ToDate",
      "not-before": _vm.fromdate
    },
    model: {
      value: (_vm.todate),
      callback: function($$v) {
        _vm.todate = $$v
      },
      expression: "todate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ToDate')),
      expression: "errors.has('ToDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('ToDate')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('button', {
    staticClass: "common-success",
    staticStyle: {
      "margin-top": "2%"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Search")]), _vm._v(" \n                  "), _c('button', {
    staticClass: "common-secondary",
    staticStyle: {
      "margin-top": "2%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetflt
    }
  }, [_vm._v("Reset")]), _vm._v(" \n                ")])], 1)])])]), _vm._v(" "), _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("THC No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Paper Work")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Print Trip Sheet")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Trip Id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("CSMID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Connection Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Vehicle No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Invoice No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsRoundTrip")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Gate Pass")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.schedulesList), function(data) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.thcno) + "\n                    ")])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openPaperWorkModel(data)
        }
      }
    }, [_c('b', [_vm._v("Paper Work")])])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openRegularPrintModal(data)
        }
      }
    }, [_c('b', [_vm._v("RegularPrint")])]), _c('br'), _vm._v(" "), _c('button', {
      staticClass: "btn btn-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.printManifestData(data.tripno, data.currenthubid, data.connectionschedulemasterid, data.connectionid)
        }
      }
    }, [_c('b', [_vm._v("Print Manifest")])]), _c('br'), _vm._v(" "), _c('button', {
      staticClass: "btn btn-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.loadingSheetPrint(data)
        }
      }
    }, [_c('b', [_vm._v("Loading Sheet Print")])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.tripno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.connectionschedulemasterid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.fullconnectionname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.vehicleno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.invoiceno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.isroundtrip == true) ? _c('span', [_vm._v("Yes")]) : _vm._e(), _vm._v(" "), (data.isroundtrip == false) ? _c('span', [_vm._v("No")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.date)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-print text-successedit fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Print GatePass"
      },
      on: {
        "click": function($event) {
          return _vm.showGatePass(data)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.schedulesList.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])], 1)], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.showPrintModal),
      callback: function($$v) {
        _vm.showPrintModal = $$v
      },
      expression: "showPrintModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Regular Print")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeRegularPrintModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('b-card', [_c('fieldset', [_c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingPrintSheet
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingPrintSheet = $event
      }
    }
  }), _vm._v(" "), (_vm.tripdatafound == true) ? _c('div', {
    attrs: {
      "id": "tripsheetContent"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Print By :")]), _vm._v(" " + _vm._s(_vm.printBy))]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Print Date :")]), _vm._v(" " + _vm._s(_vm.printDate))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("Trip Sheet")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Manual THC : ")]), _vm._v(" " + _vm._s(_vm.tripdata.VendorVehicleTripID) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Trip Start Date: ")]), _vm._v(" " + _vm._s(_vm._f("momentDate")(_vm.tripdata.TripStartTime)) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Trip End Date: ")]), _vm._v(" " + _vm._s(_vm._f("momentDate")(_vm.tripdata.TripEndTime)) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("THC Entry Time :")]), _vm._v(" " + _vm._s(_vm._f("momentTime")(_vm.tripdata.TripStartTime)) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("THC End Time :")]), _vm._v(" " + _vm._s(_vm._f("momentTime")(_vm.tripdata.TripEndTime)))]), _vm._v(" "), (_vm.tripdata.isBiker) ? _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Vehicle Type : ")]), _vm._v(" Biker")]) : _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Vehicle Type : ")]), _vm._v(" " + _vm._s(_vm.tripdata.VehicleName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Vendor Type : ")]), _vm._v(" " + _vm._s(_vm.vendortype))]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Vendor Name : ")]), _vm._v(" " + _vm._s(_vm.tripdata.VendorName ? _vm.tripdata.VendorName : 'NA'))]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Current Location : ")]), _vm._v(" " + _vm._s(_vm.currenthub) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Route Name : ")]), _vm._v(" " + _vm._s(_vm.fullConnectionName))]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Vehicle : ")]), _vm._v(_vm._s(_vm.tripdata.VehicleNo) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Driver Name : ")]), _vm._v(" "), (_vm.tripdata.DriverDetails.length > 0) ? _c('span', [_vm._v(" " + _vm._s(_vm.tripdata.DriverDetails[0].DriverName))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Trip Start Km :")]), _vm._v(" "), (_vm.tripdata.ShipmentDetails.length > 0) ? _c('span', [_vm._v(_vm._s(_vm.tripdata.ShipmentDetails[0].CurrentKM) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Trip End Km : ")]), _vm._v(" "), (_vm.tripdata.ShipmentDetails.length > 1) ? _c('span', [_vm._v(" " + _vm._s(_vm.tripdata.ShipmentDetails[_vm.tripdata.ShipmentDetails.length - 1].CurrentKM))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("No. Of Bags :")]), _vm._v(_vm._s(_vm.shipmentdataLength))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Driver Mobile Number :")]), _vm._v(" "), (_vm.tripdata.DriverDetails.length > 0) ? _c('span', [_vm._v(_vm._s(_vm.tripdata.DriverDetails[0].Mobile) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("SR Name & ID :")]), _vm._v(" "), (_vm.tripdata.isBiker) ? _c('span', [_vm._v(_vm._s(_vm.tripdata.srName + " (  " + _vm.tripdata.srId + "  )") + " ")]) : _vm._e()])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.shipmentdata), function(d, i) {
    return [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables",
      staticStyle: {
        "margin-bottom": "20px"
      },
      attrs: {
        "width": "100%"
      }
    }, [_c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "9"
      }
    }, [_c('strong', {
      staticStyle: {
        "font-size": "20px"
      }
    }, [_vm._v("Shipment Information ")])])]), _vm._v(" "), _c('tr', [_c('th', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("ShipmentId/Bag No.")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Type")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("No. of Shipments")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Physical Weight")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Chargeable Weight")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Volumetric Weight")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Origin")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      attrs: {
        "colspan": "2"
      }
    }, [_c('strong', [_vm._v("Destination")])])]), _vm._v(" "), _vm._l((d), function(data) {
      return _c('tr', [_c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.bagtype))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.shipmentcount))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.physicalweight))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.chargeableweight))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.volumetricweight))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.originhubname))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.destinationhubname))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.groupname))])])
    }), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-center"
    }), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.gettotalshipments(d)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.gettotalphywt(d))))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.gettotalcharwt(d))))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.gettotalvolwt(d))))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    })]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-left",
      attrs: {
        "colspan": "2"
      }
    }, [_c('strong', [_vm._v("Total Vol.Wt. :")]), _vm._v(" " + _vm._s(_vm._f("toFixedNum")(_vm.gettotalvolwt(d))))]), _vm._v(" "), _c('td', {
      staticClass: "text-left",
      attrs: {
        "colspan": "2"
      }
    }, [_c('strong', [_vm._v("Total Phy.Wt. :")]), _vm._v(" " + _vm._s(_vm._f("toFixedNum")(_vm.gettotalphywt(d))))]), _vm._v(" "), _c('td', {
      staticClass: "text-left",
      attrs: {
        "colspan": "6"
      }
    }, [_c('strong', [_vm._v("Total Bags : ")]), _vm._v(" " + _vm._s(d.length))])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "valign": "bottom",
        "colspan": "4",
        "rowspan": "7",
        "height": "100"
      }
    }, [_vm._v("Location Incharge Signature(Origin)")]), _vm._v(" "), _c('td', {
      attrs: {
        "valign": "bottom",
        "colspan": "6",
        "rowspan": "7",
        "height": "100"
      }
    }, [_vm._v("Location Incharge Signature(Destination)")])])], 2)])]
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDisplay),
      expression: "isDisplay"
    }],
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": !_vm.isValidPrint || !_vm.printConfig
    },
    on: {
      "click": function($event) {
        return _vm.printLineHaul('RegularPrint')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-print"
  }), _vm._v("Print")])])], 2) : _c('div', {
    staticClass: "col-md-6"
  }, [_c('span', [_vm._v("No record found")])])], 1)]), _vm._v(" "), _c('br')])], 1)])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.showSheetModal),
      callback: function($$v) {
        _vm.showSheetModal = $$v
      },
      expression: "showSheetModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Loading Sheet Print")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeSheetModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('b-card', [_c('fieldset', [_c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingSheetModal
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSheetModal = $event
      }
    }
  }), _vm._v(" "), (_vm.IsSheet == true) ? _c('div', [_c('div', {
    attrs: {
      "id": "tripsheetContent"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Print By :")]), _vm._v(" " + _vm._s(_vm.printBy))]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Print Date :")]), _vm._v(" " + _vm._s(_vm.printDate))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("Xpressbees Trip Loading Sheet")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Origin Hub : ")]), _vm._v(" " + _vm._s(_vm.hubdata.HubName) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Date: ")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.SheetPrintdata.date)) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Route :")]), _vm._v(" " + _vm._s(_vm.SheetPrintdata.fullconnectionname) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("THC No : ")]), _vm._v(" " + _vm._s(_vm.SheetPrintdata.thcno))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Vehicle No : ")]), _vm._v(" " + _vm._s(_vm.SheetPrintdata.vehicleno))])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.SheetPrintDataList), function(d, i) {
    return [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables",
      staticStyle: {
        "margin-bottom": "20px"
      },
      attrs: {
        "width": "100%"
      }
    }, [_c('tbody', [_c('tr', [_c('th', {
      staticClass: "text-center tableheader"
    }, [_c('strong', [_vm._v("Sr No.")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_c('strong', [_vm._v("Check")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_c('strong', [_vm._v("PLS Bag No")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_c('strong', [_vm._v("Destination")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_c('strong', [_vm._v("AWB No")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_c('strong', [_vm._v("MPS Count")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_c('strong', [_vm._v("Weight")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_c('strong', [_vm._v("Remarks")])])]), _vm._v(" "), _vm._l((d), function(data, index) {
      return _c('tr', [_c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "scope": "row"
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.selectedbags),
          expression: "selectedbags"
        }],
        staticStyle: {
          "font-size": "0.8em"
        },
        attrs: {
          "type": "checkbox",
          "name": 'selectedbags' + index
        },
        domProps: {
          "value": data,
          "checked": Array.isArray(_vm.selectedbags) ? _vm._i(_vm.selectedbags, data) > -1 : (_vm.selectedbags)
        },
        on: {
          "change": function($event) {
            var $$a = _vm.selectedbags,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = data,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.selectedbags = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.selectedbags = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.selectedbags = $$c
            }
          }
        }
      })]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(_vm.getBag(data.parentbagno)))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.stoppointhubname))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.paperno))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.mpscount))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.parentawbweight))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      })])
    }), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Total")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.gettotalMPSCount(d))))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.gettotalWeight(d))))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    })]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "valign": "bottom",
        "colspan": "4",
        "height": "100"
      }
    }, [_vm._v("Vehicle Loaded By")]), _vm._v(" "), _c('td', {
      attrs: {
        "valign": "bottom",
        "colspan": "4",
        "height": "100"
      }
    }, [_vm._v("Sign")])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "valign": "bottom",
        "colspan": "4",
        "height": "100"
      }
    }, [_vm._v("Fleet Supervisor/Exec.Signature")]), _vm._v(" "), _c('td', {
      attrs: {
        "valign": "bottom",
        "colspan": "4",
        "height": "100"
      }
    }, [_vm._v("Driver's Sign")])])], 2)])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": !_vm.isValidPrint || !_vm.printConfig
    },
    on: {
      "click": function($event) {
        return _vm.printGatePass('LoadingPrintSheet')
      }
    }
  }, [_vm._v("Print")])])]) : _c('div', [_c('span', [_vm._v("No Data found")])])], 1)]), _vm._v(" "), _c('br')])], 1)])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "id": "#confirmationmodal"
    },
    on: {
      "click": function($event) {
        _vm.paperWorkModel = false
      }
    },
    model: {
      value: (_vm.paperWorkModel),
      callback: function($$v) {
        _vm.paperWorkModel = $$v
      },
      expression: "paperWorkModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Paper Work Bags Detail")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closePaperWorkModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Trip Sheet No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.ParentPaperData), function(data, index) {
    return (_vm.ParentPaperData.length > 0) ? [_c('tr', {
      class: {
        opened: _vm.opened.includes(index)
      }
    }, [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "#20a8d8",
        "cursor": "pointer",
        "font-weight": "bold"
      },
      attrs: {
        "scope": "row"
      },
      on: {
        "click": function($event) {
          return _vm.getChildPaperData(data, index)
        }
      }
    }, [_vm._v(_vm._s(data.paperbagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.thcno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.paperstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))])]), _vm._v(" "), (_vm.opened.includes(index)) ? _c('tr', {
      attrs: {
        "id": 'Route' + index
      }
    }, [_c('td', {
      attrs: {
        "colspan": 12
      }
    }, [_c('br'), _vm._v(" "), _c('b-card', {
      staticStyle: {
        "margin": "15px",
        "-webkit-box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)",
        "-moz-box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)",
        "box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)"
      }
    }, [_c('legend', {
      staticClass: "header1"
    }, [_vm._v("Paper Work Bag Detail List"), _c('i', {
      staticClass: "fa fa-close fa-lg mt-2",
      staticStyle: {
        "margin-left": "74%",
        "cursor": "pointer"
      },
      attrs: {
        "title": "Close List"
      },
      on: {
        "click": _vm.closeChildPaperDataList
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-body",
      staticStyle: {
        "padding": "0.25rem !important"
      }
    }, [_c('table', {
      staticClass: "table-bordered table",
      staticStyle: {
        "position": "relative",
        "overflow": "auto",
        "font-size": "12px",
        "margin-left1": "49px"
      }
    }, [_c('thead', {
      staticClass: "table table-bordered mytable12 poform_tableheader"
    }, [_c('tr', [_c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px",
        "width": "5%"
      }
    }, [_vm._v("Paper Bag No")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px"
      }
    }, [_vm._v("Parent AWB")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px"
      }
    }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px"
      }
    }, [_vm._v("Source")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px"
      }
    }, [_vm._v("Destination")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px"
      }
    }, [_vm._v("MPS Count")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px"
      }
    }, [_vm._v("Print")])])]), _vm._v(" "), _vm._l((_vm.ChildPaperData), function(bdata, ind) {
      return (_vm.ChildPaperData.length > 0) ? _c('tbody', [_c('tr', [_c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(bdata.parentbagno))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(bdata.paperno))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(bdata.parentmpsstatus))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(bdata.currenthubname))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(bdata.stoppointhubname))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(bdata.mpscount))]), _vm._v(" "), _c('td', [_c('button', {
        staticClass: "btn btn-link",
        attrs: {
          "type": "button"
        }
      }, [_vm._v("Print")])])])]) : _vm._e()
    }), _vm._v(" "), (_vm.ChildPaperData.length == 0) ? _c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "7"
      }
    }, [_vm._v("No Bag Details added")])])]) : _vm._e()], 2)])])], 1)]) : _vm._e()] : _vm._e()
  }), _vm._v(" "), (_vm.ParentPaperData.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.viewtripmodel = false
      }
    },
    model: {
      value: (_vm.viewtripmodel),
      callback: function($$v) {
        _vm.viewtripmodel = $$v
      },
      expression: "viewtripmodel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(" Print Gate Pass")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideviewtripmodel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), (_vm.GatePassDetails.length == 0) ? _c('div', [_c('h6', {
    staticStyle: {
      "margin-left": "308px"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), (_vm.GatePassDetails.length > 0) ? _c('div', {
    staticClass: "modal-bodyfrm",
    attrs: {
      "id": "GatePass"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "float": "left"
    }
  }, [_c('span', [_c('b', [_vm._v("Print Date : ")]), _vm._v(_vm._s(_vm._f("moment")(_vm.PrintDate)))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', [_c('b', [_vm._v("Print By : ")]), _vm._v(_vm._s(_vm.PrintBy))])])]), _vm._v(" "), _vm._l((_vm.GatePassDetails), function(obj) {
    return _c('table', {
      staticClass: "table table-bordered",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('tr', {
      staticStyle: {
        "background-color": "#b3ecff",
        "height": "39px"
      }
    }, [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticStyle: {
        "margin-left": "220px",
        "font-size": "17px",
        "font-family": "Arial, Helvetica, sans-serif"
      }
    }, [_c('b', [_vm._v("TRIP SHEET SUMMARY / GATE PASS")])])])]), _vm._v(" "), _c('tr', {
      staticStyle: {
        "background-color": "#fffefe"
      }
    }, [_c('td', [_c('span', [_c('b', [_vm._v("Hub Center : ")]), _vm._v(_vm._s(obj.CurrentHub))])]), _vm._v(" "), _c('td', [_c('span', [_c('b', [_vm._v("Driver Name : ")]), _vm._v(" " + _vm._s(obj.drivername))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', [_c('b', [_vm._v("THC Number : ")]), _vm._v(_vm._s(obj.thcno))])]), _vm._v(" "), _c('td', [_c('span', [_c('b', [_vm._v("Driver Mobile No : ")]), _vm._v(" " + _vm._s(obj.mobilenumber == "null" ? '' : obj.mobilenumber))])])]), _vm._v(" "), _c('tr', {
      staticStyle: {
        "background-color": "#fffefe"
      }
    }, [_c('td', [_c('span', [_c('b', [_vm._v("Trip Start date : ")]), _vm._v(_vm._s(_vm._f("moment")(obj.sealdate)))])]), _vm._v(" "), (obj.isbikertrip) ? _c('td', [_c('span', [_c('b', [_vm._v("Vehicle Type : ")]), _vm._v("Biker")])]) : _c('td', [_c('span', [_c('b', [_vm._v("Vehicle Type : ")]), _vm._v(" " + _vm._s(obj.vehiclename))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', [_c('b', [_vm._v("Number Of Bags : ")]), _vm._v(" " + _vm._s(obj.totalocalbag))])]), _vm._v(" "), _c('td', [_c('span', [_c('b', [_vm._v("Vendor Name : ")]), _vm._v(" " + _vm._s(obj.vendorname == "null" ? "NA" : obj.vendorname))])])]), _vm._v(" "), _c('tr', {
      staticStyle: {
        "background-color": "#fffefe"
      }
    }, [_c('td', [_c('span', [_c('b', [_vm._v("Total Weight : ")]), _vm._v(" " + _vm._s(_vm.formatWeight(obj.totalweight)) + " kg")])]), _vm._v(" "), _c('td', [_c('span', [_c('b', [_vm._v("Vehicle No. : ")]), _vm._v(" " + _vm._s(obj.vehicleno))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', [_c('b', [_vm._v("Start Location : ")]), _vm._v(" " + _vm._s(obj && obj.connectionname ? obj.connectionname.split('-')[0] : 'N/A'))])]), _vm._v(" "), _c('td', [_c('span', [_c('b', [_vm._v("Vehicle Seal No : ")]), _vm._v(" " + _vm._s(obj.vehiclesealno))])])]), _vm._v(" "), _c('tr', {
      staticStyle: {
        "background-color": "#fffefe"
      }
    }, [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', [_c('b', [_vm._v("Route Name : ")]), _vm._v(" " + _vm._s(obj.connectionname))])])])])
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered centered-table",
    staticStyle: {
      "width": "100%",
      "border-collapse": "collapse",
      "font-family": "Arial, sans-serif",
      "font-size": "14px"
    }
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px",
      "font-size": "16px"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_c('b', [_vm._v("DESTINATION LOAD SUMMARY")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background-color": "#e0e0e0",
      "text-align": "center"
    }
  }, [_c('th', [_vm._v("Transit Location")]), _vm._v(" "), _c('th', [_vm._v("Qty (B2C Bags)")]), _vm._v(" "), _c('th', [_vm._v("Qty (B2B MPS)")]), _vm._v(" "), _c('th', [_vm._v("EBN Count")]), _vm._v(" "), _c('th', [_vm._v("Entry Time")]), _vm._v(" "), _c('th', [_vm._v("Exit Time")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.DestLoadCountUpdated), function(row, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('td', [_vm._v(_vm._s(row.transit_location))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.b2c_bag_count))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.b2b_mps_count))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ebn_count))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.entry))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.exit))])])
  }), 0)]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered",
    staticStyle: {
      "width": "100%",
      "border-collapse": "collapse",
      "font-family": "Arial, sans-serif",
      "font-size": "14px"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "20%",
      "height": "40px"
    }
  }, [_c('b', [_vm._v("Note")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%",
      "height": "40px"
    }
  }, [_c('b')]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "30%",
      "text-align": "center"
    },
    attrs: {
      "rowspan": "3"
    }
  }, [_c('b', [_vm._v("Seal & signature - Gate Pass")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "40px"
    }
  }, [_c('b', [_vm._v("Date")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "height": "40px"
    }
  }, [_c('b')])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered",
    staticStyle: {
      "width": "100%",
      "border-collapse": "collapse",
      "font-family": "Arial, sans-serif",
      "font-size": "14px"
    }
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px",
      "font-size": "16px"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_c('b', [_vm._v("E-WAYBILL NUMBER ANNEXURE (B2C)")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background-color": "#e0e0e0",
      "text-align": "center"
    }
  }, [_c('th', [_vm._v("E-Way Bill no.")]), _vm._v(" "), _c('th', [_vm._v("Origin Destination")]), _vm._v(" "), _c('th', [_vm._v("Invoice Number")]), _vm._v(" "), _c('th', [_vm._v("GST Number")]), _vm._v(" "), _c('th', [_vm._v("Invoice Value")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.ebnDetailsB2C), function(row) {
    return _c('tr', {
      key: _vm.index
    }, [_c('td', [_vm._v(_vm._s(row.ebn))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.origin_destination))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.invoicenumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.gstnumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.invoicevalue))])])
  }), 0)]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered",
    staticStyle: {
      "width": "100%",
      "border-collapse": "collapse",
      "font-family": "Arial, sans-serif",
      "font-size": "14px"
    }
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px",
      "font-size": "16px"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_c('b', [_vm._v("E-WAYBILL NUMBER ANNEXURE (B2B)")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background-color": "#e0e0e0",
      "text-align": "center"
    }
  }, [_c('th', [_vm._v("E-Way Bill no.")]), _vm._v(" "), _c('th', [_vm._v("Origin Destination")]), _vm._v(" "), _c('th', [_vm._v("Invoice Number")]), _vm._v(" "), _c('th', [_vm._v("GST Number")]), _vm._v(" "), _c('th', [_vm._v("Invoice Value")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.ebnDetailsB2B), function(row) {
    return _c('tr', {
      key: _vm.index
    }, [_c('td', [_vm._v(_vm._s(row.ebn))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.origin_destination))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.invoicenumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.gstnumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.invoicevalue))])])
  }), 0)])], 2) : _vm._e(), _vm._v(" "), (_vm.GatePassDetails.length > 0) ? _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "common-success",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        return _vm.printGatePass('GatePass')
      }
    }
  }, [_vm._v("Print")])]) : _vm._e()])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.invalidTokenModal),
      callback: function($$v) {
        _vm.invalidTokenModal = $$v
      },
      expression: "invalidTokenModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.invalidtokenmsg))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_vm._v("Cancel")])])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b10c32","hasScoped":true}!./src/views/components/NetworkManagement/searchNetworkTrip/searchNetworkTrip.html
// module id = 963
// module chunks = 2